import { swoopApiUrl } from '@/api'

export const generateCreditReport = companyId => swoopApiUrl.post(`/api/companies/${companyId}/creditreports`)

export const getCreditReport = companyId => swoopApiUrl.get(`/api/companies/${companyId}/creditreports`)

export const getCreditReportPdf = companyId => swoopApiUrl.get(`/api/companies/${companyId}/creditreports/download`, { responseType: 'blob' })

export const getDownloadPermission = companyId => swoopApiUrl.get(`/api/companies/${companyId}/creditreports/candownload`)
